import React, { useState } from "react"
import PropTypes from "prop-types"
import { Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { StruckTotal } from "./OrderSummary"
import styles from "./BookingForm.module.css"

// The order's promo code and total, under its experiences (Figma 5796:176503): "Add Promo-code"
// opens the promo field (`promoInput`, which also lists the applied code; none for an order of several
// experiences until its promo rules exist), then the Order Total.
// `subtotal` (the price before taxes and fees, with its Adjust control) comes before the total, so the
// amounts read top to bottom (QA Ticketing #43); `children` follow it: what is charged now (card fee,
// deposit).
const OrderTotal = ({ total, totalBeforeAdjustments, promoInput, isPromoApplied, subtotal, children }) => {
  const { t } = useTranslation()
  const [isPromoOpen, setIsPromoOpen] = useState(false)
  return (
    <Flex vertical gap="var(--spacing-xs)" className={styles.orderTotalBox}>
      {promoInput &&
        (isPromoOpen || isPromoApplied ? (
          promoInput
        ) : (
          <Button type="link" className={styles.addPromoLink} onClick={() => setIsPromoOpen(true)}>
            {t("booking.order_summary.add_promo")}
          </Button>
        ))}
      {subtotal}
      <Flex justify="space-between" align="baseline" gap="var(--spacing-m)" className={styles.orderTotalRow}>
        <span>{t("booking.order_summary.order_total")}</span>
        <StruckTotal total={total} totalBeforeAdjustments={totalBeforeAdjustments} />
      </Flex>
      {children}
    </Flex>
  )
}

OrderTotal.propTypes = {
  total: PropTypes.number.isRequired,
  totalBeforeAdjustments: PropTypes.number,
  promoInput: PropTypes.node,
  isPromoApplied: PropTypes.bool,
  subtotal: PropTypes.node,
  children: PropTypes.node
}

OrderTotal.defaultProps = {
  totalBeforeAdjustments: 0,
  promoInput: null,
  isPromoApplied: false,
  subtotal: null,
  children: null
}

export default OrderTotal
